import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloCmdForfait extends AloBase {              
    fftId:number    
    usrId:number|null
    cftValiditeM:number|null
    cftNbEntree:number
    nbUsed:number
    cftDatengagement:string
    isAbonnement:boolean
    psnId:number|null
}

export const getDefaultAloCmdForfait = ():AloCmdForfait => {
    return {  
        ...getDefaultAloBase(),                
        fftId:0,
        usrId:null,
        cftValiditeM:null,
        cftNbEntree:0,
        nbUsed:0,
        cftDatengagement:'',
        isAbonnement:false,
        psnId:null
    }
}

export const cleanAloCmdForfait = (forfaitRow:AloCmdForfait) => {
    if(!forfaitRow) return    
    if(!forfaitRow.id) delete forfaitRow.id     
    if(!forfaitRow.fftId) delete forfaitRow.fftId   
    if(!forfaitRow.usrId) delete forfaitRow.usrId     
    if(!forfaitRow.psnId) delete forfaitRow.psnId     
}